// extracted by mini-css-extract-plugin
module.exports = {"social":"SocialLink_social___cQqL","social__link":"SocialLink_social__link__luIi2","social__link__particles":"SocialLink_social__link__particles__nrvMr"};